import { MarketNews } from '@msrllabs/pt-api';
import { API_CONFIG } from '@msrllabs/pt-api/http';

import { fetchMarketDataJson } from './apiUtils';

export const getNews = () => {
  return fetchMarketDataJson<MarketNews[]>(`${API_CONFIG.PT_WEB_ENDPOINT}/aqt/news_feed/v1/marketNews/general`);
};

export const getNewsByInstrumentId = async (instrumentId: string, fr?: Date, to?: Date, page: number = 0, size: number = 20) => {
  const searchParams = new URLSearchParams({
    page: page.toString(),
    size: size.toString(),
  });
  if (fr) searchParams.set('fr', fr.toISOString());
  if (to) searchParams.set('to', to.toISOString());
  return fetchMarketDataJson<MarketNews[]>(
    `${API_CONFIG.PT_WEB_ENDPOINT}/aqt/news_feed/v1/marketNews/instruments/${instrumentId}?${searchParams.toString()}`
  );
};

export const getNewsByTopic = (topic: string, pageNumber = 0, size = 20) => {
  let topic_q = topic != null ? `&topic=${encodeURIComponent(topic)}` : '';
  return fetchMarketDataJson<MarketNews[]>(
    `${API_CONFIG.PT_WEB_ENDPOINT}/aqt/news_feed/v1/marketNews?page=${pageNumber}&size=${size}${topic_q}`
  );
};

export const getNewsByType = (type: string, pageNumber = 0, size = 20) => {
  return fetchMarketDataJson<MarketNews[]>(
    `${API_CONFIG.PT_WEB_ENDPOINT}/aqt/news_feed/v1/marketNews?page=${pageNumber}&size=${size}&type=${encodeURIComponent(type)}`
  );
};

export const getNewsTopics = () => {
  return fetchMarketDataJson<string[]>(`${API_CONFIG.PT_WEB_ENDPOINT}/aqt/news_feed/v1/marketNews/topics`);
};
